import React, { Fragment } from 'react';
import { TwitterPicker } from 'react-color';
import { randomHex } from '../common/utils';

class CategoryColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: props.color,
            showPicker: false,
        };
    }

    onClickColor = (colorData) => {
        const color = colorData.hex.substring(1);
        this.setState({ color });

        if (this.props.pickColor) {
            this.props.pickColor(color);
        }
    };

    generateRandomHex = (e) => {
        e.preventDefault();

        const hex = randomHex();

        this.setState({ color: hex });

        if (this.props.pickColor) {
            this.props.pickColor(hex);
        }
    };

    render() {
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        };

        const genBtnStyle = {
            position: 'absolute',
            top: '51px',
            right: '15px',
            borderColor: 'transparent',
            background: 'rgb(240, 240, 240)',
            height: '30px',
            width: '30px',
            borderRadius: '0px 4px 4px 0px',
            float: 'left',
            color: 'rgb(152, 161, 164)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
        };

        return (
            <Fragment>
                <label className="bold block col-12 mb1">
                    Color
                </label>
                <div
                    className="btn rounded"
                    style={{ backgroundColor: `#${this.state.color}`, height: '26px', width: '10px' }}
                    onClick={() => this.setState({ showPicker: !this.state.showPicker })}
                />
                <input
                    name="color"
                    type="hidden"
                    id="color"
                    value={this.state.color}
                />
                {this.state.showPicker
                    && (
                        <div style={{ position: 'absolute', zIndex: 2 }}>
                            <div style={cover} onClick={() => this.setState({ showPicker: false })} />
                            <TwitterPicker
                                color={`#${this.state.color}`}
                                onChange={this.onClickColor}
                                colors={['#D8D8D8', '#F4346C', '#00B2F2', '#FFD33B', '#43ADA9', '#3465C6', '#ED921E', '#66CC78', '#C482FF', '#F82B60']}
                            />
                            <button style={genBtnStyle} id="generateRandomHex" onClick={this.generateRandomHex}>
                                <i className="demo-icon icon-arrows-cw" />
                            </button>
                        </div>
                    )}
            </Fragment>
        );
    }
}

export default CategoryColorPicker;
